export default __webpack_public_path__ + "static/media/CocheSeguro.37848202.svg";